import React, { useState, useEffect, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import debounce from "lodash/debounce";
import { SelectBox } from 'devextreme-react/select-box';
import AccordionReact from 'devextreme-react/accordion';
import { Button } from 'devextreme-react/button';
import { alert, confirm } from 'devextreme/ui/dialog';
import { GridLayout } from "../../common/GridLayout";
import { Localization } from "../../common/Localization";
import notify from 'devextreme/ui/notify';
import LookupPopup from './LookupPopup';
import LookupProfilePopup from './LookupProfilePopup';
import DeleteReceiptDialog from "./DeleteReceiptDialog";
import DataSource from "devextreme/data/data_source";
import { TextBox } from 'devextreme-react/text-box';
import { TextArea } from 'devextreme-react';
import ItemModeGrid from "./ItemModeGrid";
import DateBox from 'devextreme-react/date-box';
import ToolbarAccordian, { Item as ItemAccordian } from "devextreme-react/toolbar";
import { LoadPanel } from 'devextreme-react/load-panel';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnChooserSearch,
  Selection,
  HeaderFilter,
  Editing,
  ColumnFixing,
  StateStoring,
  Toolbar,
  Item
} from "devextreme-react/data-grid";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import axios from "axios";
import data from "../../assets/apiRoutes.json";
import { Reset_Items } from "../../redux/actions/receipt";
import * as PermissionsConstants from "../../const/constants";
import { Popup } from "devextreme-react/popup";
import Consignee from "./consignee/AddConsignee";
import ScrollView from "devextreme-react/scroll-view";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { createConcurrencyAwareStore, refreshGridOnConflict } from "../../common/dataStore";
import { CONCURRENCY_HANDLED, getApiErrorMessage } from "../../common/concurrency";
import { MESSAGES } from "../../common/Messages";
import { disableTransDate, ABECASUSER_LOGIN_TYPE } from "../../common/permissions";
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
import { GetFormatedDateWithTime } from '../../common/Utils';

var receiptIdVar = "";
var dialogMessage1 = "";
var dialogMessage2 = "";
var detailDataGridMode = "ExpressLotMode";
var detailItemDataGridMode = "ItemMode";
var customerRowId = "";
let isAbecasUser = false;
var detailDataGrid = React.createRef();
const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];
let profileObjt;
function CreateReceipt(props) {
  const consigneeLookup = 0;
  const shipperLookup = 1;
  const carrierLookup = 2;
  const customerLookup = 3;
  
  let detailDataGridModes;
  if (props.rolePermission === PermissionsConstants.TransactionReceipt) {
    detailDataGridModes = [
      { value: 'ExpressItemMode', text: 'Express Item Mode' },
      { value: 'ExpressLotMode', text: 'Express Lot Mode' },
      { value: 'ItemMode', text: 'Item Mode' },
    ];
  } else {
    detailDataGridModes = [
      { value: 'ExpressItemMode', text: 'Express Item Mode' },
      { value: 'ExpressLotMode', text: 'Express Lot Mode' },
    ];
  }
  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };
  const initialTransactionState = {
    recordNumber: "",
    shipperBolNumber: "",
    reference: "",
    transactionNumber: "",
    transactionDate: new Date(),
    transactionGroup: "",
    userDefinedReference2: "",
    actualreceivedshipeddate: "",
    rShipper: "",
    rConsignee: "",
    comment: "",
    rCarrier: "",
    shipperVal: "",
    consigneeVal: "",
    carrierVal: "",
    shipperId: "",
    consigneeId: "",
    carrierId: "",
    stage: "P",
    status: "O",
    companyid: "SB",
    module: "WM",
    freightChargeType: "N",
    transactionType:
      props.rolePermission === PermissionsConstants.TransactionReceipt
        ? "R"
        : "S",
    recordtype: "R",
    customerId: "",
    rCustomer: "",
    customerVal: "",
    profileId: "",
    rProfile: "",
    profileVal: ""
  };

  var setFoucsToLotFilterTextBox = false;
  isAbecasUser = props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE;
  const [createBtnURL, setcreateBtnURL] = React.useState("/wm/transaction/create-receipt");
  const [shipperData, setshipperData] = useState({});
  const [carrierData, setCarrierData] = useState({});
  const [customerData, setCustomerData] = useState({});
  const [profileData, setProfileData] = useState({});
  const [guidForconsignee, setGuidForConsignee] = useState([]);
  const [guidForShipper, setGuidForShipper] = useState([]);
  const [guidForCarrier, setGuidForCarrier] = useState([]);
  const [guidForCustomer, setGuidForCustomer] = useState([]);
  const [guidForProfile, setGuidForProfile] = useState([]);
  const [searchPanelStatus, setSearchPanelStatus] = useState(true);
  const [displayItemModeGrid, setDisplayItemModeGrid] = useState(false);

  const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
  const [loadPanelVisible, setLoadPanelVisible] = useState(false);
  const [showIndicator, setShowIndicator] = useState(true);
  const [shading, setShading] = useState(true);
  const [showPane, setShowPane] = useState(true);
  const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
  const position = { of: '#accordion-containe2' };
  const dataGrid = useRef(null);
  const profileDataGrid = React.createRef();
  const allowedPageSizes = [10, 100, 200, 500, "all"];
  var accessToken = props.oidc.user.access_token;
  const dispatch = useDispatch();
  const history = useHistory();
  const [consigneeData, setConsigneeData] = useState({});
  const [poError, setPOError] = useState("");
  const [customerError, setCustomerError] = useState("");
  const [profileError, setProfileError] = useState("");
  const [dialogToAddItems, setDialogToAddItems] = useState(false);
  const [disableReciveShippingDate, setdisableReciveShippingDate] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [dateError, setDateError] = useState("");
  const [consigneeIdInputToDisable, setConsigneeIdInputToDisable] =
    useState(false);
  const [consigneeInfoInputToDisable, setConsigneeInfoInputToDisable] =
    useState(false);
  const [consigneeSearchDisable, setConsigneeSearchDisable] = useState(false);
  const [consigneeInfo, setConsigneeInfo] = useState("");
  const [disable, setDisable] = useState(false);
  const [openDialogForTransaction, setOpenDialogForTransaction] =
    useState(false);
  const [addConsigneePopup, setaddConsigneePopup] = useState(false);
  const [selectedValue, setSelectedValue] = useState(detailDataGridMode);
  const [headerId, setHeaderId] = useState(receiptIdVar);
  const [selectedCustomerId, setSelectedCustomerId] = useState();
  const [consigneeIdPopupValue, setConsigneeIdPopupValue] = useState("");
  const [loadIndicatorVisible, setLoadIndicatorVisible] = useState(false);
  const [deleteButtonDisabled, setDeleteButtonDisabled] = useState(true);
  const [deleteReceiptDialogOpen, setDeleteReceiptDialogOpen] = useState(false);
  const [allowedReceiptDeleteBtn, setAllowedReceiptDeleteBtn] = useState(false);
  const [allowedShipmentDeleteBtn, setAllowedShipmentDeleteBtn] = useState(false);
  const [disableShippingDate, setDisableShippingDate] = useState(false);
  const [detailCount, setDetailCount] = useState(0);
  const [customerDisabled, setCustomerDisabled] = useState(false);
  const [profileDisabled, setProfileDisabled] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const [dataSource, setDataSource] = useState(null);
  const detailDataGridModeChanged = (e) => {
    if (e.value == "ItemMode") {
      setHeaderId(receiptIdVar);
      setDisplayItemModeGrid(true);
      setSelectedValue(e.value);
      detailItemDataGridMode = e.value;
      setReloadKey(prevKey => prevKey + 1);
    } else {
      setDisplayItemModeGrid(false);
      detailDataGridMode = e.value;
      setSelectedValue(e.value);
      if(detailDataGrid.current && typeof detailDataGrid.current.instance === 'function') {
        const instance = detailDataGrid.current.instance();
        if (instance && typeof instance.refresh === 'function') {
          instance.refresh();
        }
      }
    }
  }



  const handleOpenDeleteReceiptDialog = (e) => {
    e.event.stopPropagation();
    setDeleteReceiptDialogOpen(true);
  };

  const handleCloseDeleteReceiptDialog = () => {
    setDeleteReceiptDialogOpen(false);
  };

  const handelReset = () => {
    setDisable(false);
    setProfileDisabled(false);
    setCustomerDisabled(false);
    setPrintButtonDisabled(true);
    setDeleteButtonDisabled(true);
    setReceiptId("");
    receiptIdVar = "";
    setHeaderId(receiptIdVar);
    initialTransactionState.transactionDate = new Date();
    setTransaction(initialTransactionState);
    setProfileData({});
    setGuidForCarrier([]);
    setCarrierData({});
    setCustomerData({});
    customerRowId = "";
    setCarrierData({});
    setGuidForConsignee([]);
    setConsigneeData({});
    setConsigneeInfo("");
    setGuidForShipper([]);
    setshipperData({});

  }
  const SHIPPER_ID_TO = "shipperidto";
  const lookups = {};
  lookups[SHIPPER_ID_TO] = {
    name: "ShipperTo",
    label: "Shipper To:",
    lookupType: 5
  };
  const handleClosePopUpCallback = (ChildData) => {
    setConsigneeIdPopupValue(ChildData.rowid);
    setTransaction({
      ...transaction,
      consigneeId: ChildData.ridentity
    });

    setConsigneeData({
      rowid: ChildData.ridentity,
      name: ChildData.name,
      identityId: ChildData.identityid,
    });

    setConsigneeInfo(getConsigneeInfo(ChildData));
    setaddConsigneePopup(false);
    console.log(ChildData);
  };

  const exportReport = (e) => {
    e.event.stopPropagation();
    var report = new Object();
    report.Key = "WMR0049";
    report.Name = "WMR0049";

    var whereInfo = new Object();
    whereInfo.FieldType = 0; //ParameterTypeEnum.String;
    whereInfo.FieldName = "TRANSACTIONNUMBER";
    whereInfo.Operation = 3; //OperationEnum.Equal
    whereInfo.Origin = "WMTRANSACTIONHEADER.TRANSACTIONNUMBER";
    whereInfo.From = transaction.transactionNumber;
    whereInfo.To = transaction.transactionNumber;
    report.FilterWhereInfoList = [];
    report.FilterWhereInfoList.push(whereInfo);
    setLoadIndicatorVisible(true);
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.reports.GenerateReport}`,
        report,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        setLoadIndicatorVisible(false);
        if (
          res.hasOwnProperty("data") &&
          res.data != null &&
          res.data != undefined
        ) {
          if (res.data.isSuccess) {
            window.open(
              `${window._env_.REACT_APP_APIS}/${data.reports.GetReportFile}?fileName=${res.data.fileName}`,
              "_blank"
            );
          } else {
            alert(
              "Cannot generate report. Error:  " + res.data.errorMessage,
              "Error"
            );
          }
        } else {
          alert("Cannot generate report", "Error");
        }
      })
      .catch((err) => {
        setLoadIndicatorVisible(false);
        alert(err, "Error");
      });
  };



  const [transaction, setTransaction] = useState(initialTransactionState);

  const dataBase =
    props.ReceiptReducer.wmTransactionDatabase !== ""
      ? props.ReceiptReducer.wmTransactionDatabase
      : "";

  const [transactionType, setTransactionType] = useState({
    transactionType:
      props.rolePermission === PermissionsConstants.TransactionReceipt
        ? "R"
        : props.permission === PermissionsConstants.TransactionAdjustment
          ? "A"
          : "S",
    dbName:
      props.ReceiptReducer.wmTransactionDatabase !== ""
        ? props.ReceiptReducer.wmTransactionDatabase
        : "",
  });

  const [printButtonDisabled, setPrintButtonDisabled] = useState(transaction?.transactionNumber ? false : true);


  const loadTransactionFromProfile = (profileId) => {
    ;
    console.log(profileData);

    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.GetTransactionFromProfile}?transactionType=${transactionType.transactionType}&profileId=${profileId}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        if (res.hasOwnProperty("data") && res.data != null && res.data != undefined && res.data != "") {
          ;
          if (res.data.shipper != null && res.data.shipper != undefined) {

            let tempShipperArray = new Array();
            tempShipperArray.push(res.data.shipper);
            console.log(tempShipperArray);
            setGuidForShipper(tempShipperArray);
            console.log(res.data.shipper);
            setshipperData(res.data.shipper);
          }
          else {
            setGuidForShipper([]);
            setshipperData({});
          }

          if (res.data.carrier != null && res.data.carrier != undefined) {
            let tempCarrierArray = new Array();
            tempCarrierArray.push(res.data.carrier);
            setGuidForCarrier(tempCarrierArray);
            setCarrierData(res.data.carrier);
          }
          else {
            setGuidForCarrier([]);
            setCarrierData({});
          }

          if (res.data.consigneeInfo?.rowid != null && res.data.consigneeInfo?.rowid != undefined) {
            let tempConsigneeArray = new Array();
            tempConsigneeArray.push(res.data.consigneeInfo);
            setGuidForConsignee(tempConsigneeArray);
            setConsigneeData(res.data.consigneeInfo);
            setConsigneeInfo(res.data?.consigneeInfo?.info);
          }
          else {
            setGuidForConsignee([]);
            setConsigneeData({});
            setConsigneeInfo("");
          }

          if (res.data.customer != null && res.data.customer != undefined) {
            let tempCustomerArray = new Array();
            tempCustomerArray.push(res.data.customer);
            setGuidForCustomer(tempCustomerArray);
            setCustomerData(res.data.customer);
            customerRowId = res.data.customer.rowid;
            if (detailDataGrid.current?.instance()) {
              detailDataGrid.current.instance().refresh();
            }
          }
          else {
            setGuidForCustomer([]);
            setCustomerData({});
            customerRowId = "";
            if (detailDataGrid.current?.instance()) {
              detailDataGrid.current.instance().refresh();
            }
          }

          var data = transaction;
          data.shipperBolNumber = res.data.transaction?.shipperbolnumber;
          data.actualreceivedshipeddate = res.data.transaction?.actualreceivedshippeddatetime;
          data.comment = res.data.transaction?.comment;
          data.reference = res.data.transaction?.reference;
          data.carrierVal = res.data.carrier?.name;
          data.rCarrier = res.data.carrier?.rowid;
          data.shipperVal = res.data.shipper?.name;
          data.rShipper = res.data.shipper?.rowid;
          data.rConsignee = res.data.consigneeInfo?.rowid;
          data.consigneeVal = res.data.consigneeInfo?.name;
          data.freightChargeType = res.data.transaction?.freightchargetype;
          data.transactionGroup = res.data.transaction?.transactiongroup;
          data.customerVal = res.data.customer?.name;
          data.rCustomer = res.data.customer?.rowid;
          data.concurrencyToken = res.data.transaction?.concurrencyToken;
          setTransaction(data);
        }
      })
      .catch((err) => {
        console.log(err, "error in getting shipper from profile");
      });
  };

  const getTransactionData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.GetAllTransactions}`,
        transactionType,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        props.loadTransactionsData(res.data);
      });
  };

  const handelShipperBolChange = (e) => {

    const name = "shipperBolNumber";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };

  const handelCommentChange = (e) => {

    const name = "comment";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };
  const handelreferenceChange = (e) => {

    const name = "reference";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };


  const onInputValueChange = (e) => {

    const { name } = e.component.option('name');
    const value = e.value;
    if (name === "actualreceivedshipeddate") {
      // Check user permissions
      if (props.oidc.user.profile.hasOwnProperty("WMTRANSDATECONTROL") && props.oidc.user.profile.WMTRANSDATECONTROL === "B") {
        const compare = Date.parse(value);
        const today = Date.now(); // Use Date.now() to get the current timestamp
        if (compare < today) {
          alert("Receiving date must be greater than today's date", "Error");
          return;
        }
      }
    }
    if (name) {
      setTransaction({ ...transaction, [name]: value });
    }
  };
  const onInputChange = (e) => {


    if (e.target.name == "actualreceivedshipeddate") {
      if (props.oidc.user.profile.hasOwnProperty("WMTRANSDATECONTROL") && props.oidc.user.profile.WMTRANSDATECONTROL == "B") {
        var compare = Date.parse(e.target.value);
        var today = Date().now();
        if (compare < today) {
          alert("Receiving date must be greater than today's date", "Error");
          return;
        }
      }
    }

    setTransaction({ ...transaction, [e.target.name]: e.target.value });



  };

  const resetErrors = () => {
    setPOError("");
    setDateError("");
    setCustomerError("");
  };
  const [receiptId, setReceiptId] = useState("");

  const initialTotals = {
    items: 0.00,
    ordered: 0.00,
    netWeight: 0.00,
    actual: 0.00,
    grossWeight: 0.00,
    inventory: 0.00,
    amount: 0.00,
  };
  const [selectedTotals, setSelectedTotals] = useState(initialTotals);
  
  const changeTotals = async () => {
    try {
      if (!receiptId || receiptId === "00000000-0000-0000-0000-000000000000") {
        setSelectedTotals(initialTotals);
      } 
      else
      {
        const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.Transaction.GetTotals}`, {
          params: { headerRowId: receiptId },
          headers: { access_token: accessToken, Authorization: `Bearer ${accessToken}` },
        });
        const result = response.data?.result || response.data;
        setSelectedTotals(result);
      }
    } catch (error) {
      console.error("Error fetching totals:", error);
    }
  }

  const onSaveTransaction = (e) => {

    e.event.stopPropagation();
    let errors = [];

    if (transaction.reference === "") {
      setPOError("P.O. No field is required");
      errors.push("P.O. No field is required");
      notify(
        {
          message: "P.O. No field is required!",
          width: 100,
        },
        'error',
        3000,
      );
    } else {
      setPOError("");
    }

    if ((!transaction.transactionDate) || transaction.transactionDate === "") {
      setDateError("Date is required!");
      errors.push("Date is required!");
      notify(
        {
          message: "Date is required!",
          width: 100,
        },
        'error',
        3000,
      );
    } else {
      setDateError("");
    }

    if (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE) {
      if (profileData?.rowid == null || profileData?.rowid == undefined) {
        setProfileError("Profile is required");
        errors.push("Profile is required");
        notify(
          {
            message: "Profile is required",
            width: 100,
          },
          'error',
          3000,
        );
        return;
      } else {
        setProfileError("");
      }

      if (customerData?.rowid == null || customerData?.rowid == undefined) {
        setCustomerError("Customer is required");
        errors.push("Customer is required");
        notify(
          {
            message: "Customer is required",
            width: 100,
          },
          'error',
          3000,
        );
        return;
      } else {
        setCustomerError("");
      }
      if ((!transaction.reference) || transaction.reference === "") {
        setPOError("P.O. No field is required");
        errors.push("P.O. No field is required");
        notify(
          {
            message: "P.O. No field is required!",
            width: 100,
          },
          'error',
          3000,
        );
      } else {
        setPOError("");
      }
    }

    if (errors.length == 0) {
      /*
      if (receiptItemsObect.length === 0) {
        setDialogToAddItems(true);
      }
      */

      // if (receiptItemsObect.length > 0) {
      if (true) {
        setDisable(true);
        // dispatch(Create_New_Receipt(transactionDetailRequest));
        setLoadPanelVisible(true);
        var transactionDetailRequest = {
          // Tells the API which version of the header this edit started from.
          concurrencyToken: transaction.concurrencyToken,
          shipperBolNumber: transaction.shipperBolNumber,
          reference: transaction.reference,
          transactionNumber: transaction.transactionNumber,
          rShipper: shipperData?.rowid,
          comment: transaction.comment,
          rCarrier: carrierData?.rowid,
          rConsignee: consigneeData?.rowid,
          transactionDate: GetFormatedDateWithTime(transaction.transactionDate),
          actualreceivedshippeddatetime: GetFormatedDateWithTime(transaction.actualreceivedshipeddate),
          status: transaction.status,
          stage: transaction.stage,
          companyid: transaction.companyid,
          module: transaction.module,
          recordtype: transaction.recordtype,
          transactionType: transaction.transactionType,
          dbName: dataBase,
          freightChargeType: transaction.freightChargeType,
          transactionGroup: transaction.transactionGroup,
          rCustomer: props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE ? customerData?.rowid : null,
          rProfile: profileData?.rowid,
          UserDefinedReference2: transaction.userDefinedReference2
        };

        if (props.oidc.user.profile.hasOwnProperty("RECVSHIPDTACCESS") && props.oidc.user.profile.RECVSHIPDTACCESS == "D") {
          transactionDetailRequest.actualreceivedshippeddatetime = null;
        }

        if (receiptIdVar != "") {
          transactionDetailRequest.rowid = receiptIdVar;
          setHeaderId(receiptIdVar);
        }

        axios.post
          (
            `${window._env_.REACT_APP_APIS}/${data.Receipt.ValidateReference}`,
            transactionDetailRequest,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            setTimeout(hideLoadPanel, 1000);
            if (res.data.type == "warning") {
              let result = confirm("<i>" + res.data.message + "</i>", "Warning");
              result.then((dialogResult) => {
                if (dialogResult) {
                  SaveTransaction(transactionDetailRequest);
                }
                else {
                  setDisable(false);

                }
              });

            }
            else if (res.data.type == "error") {
              alert(res.data.message, "Error");
              setDisable(false);
            }
            else {
              SaveTransaction(transactionDetailRequest);
            }
          })
          .catch((err) => {
            setDisable(false);
            setTimeout(hideLoadPanel, 1000);
            alert(err, "Error");
          });
      }
    }
  };

  const SaveTransaction = (transactionDetailRequest) => {
    if (receiptIdVar == "") {
      axios.post
        (
          `${window._env_.REACT_APP_APIS}/${data.Receipt.CreateTransactions}`,
          transactionDetailRequest,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
            },
          }
        )
        .then((res) => {
          // dispatch(onCheckBoxClick(res.data));
          if (res.data.success) {
            setProfileDisabled(true);
            setCustomerDisabled(true);
            setPrintButtonDisabled(false);
            setDeleteButtonDisabled(false);
            setReceiptId(res.data.wmtransactionheader.rowid);
            setTransaction({
              ...transaction,
              ["transactionNumber"]: res.data.wmtransactionheader.transactionnumber,
              ["recordNumber"]: res.data.wmtransactionheader.recordNumber
            });
            handleClickOpen();
            receiptIdVar = res.data.wmtransactionheader.rowid;
            setSelectedCustomerId(res.data.wmtransactionheader.rCustomer);
            setHeaderId(receiptIdVar);
            changeTotals();
            setDisable(false);
            resetErrors();
            
          }
          else {
            alert(res.data.message, "Error");
            setDisable(false);
            resetErrors();
            setPrintButtonDisabled(true);
          }
        })
        .catch((err) => {
          // A version conflict is already handled globally by the axios interceptor.
          if (err?.[CONCURRENCY_HANDLED]) {
              return;
          }
          // A refusal is now a real 4xx and lands here rather than in the else branch above; this catch
          // previously reset state without telling the user anything.
          alert(getApiErrorMessage(err, MESSAGES.ERROR), "Error");
          setDisable(false);
          resetErrors();
          setPrintButtonDisabled(true);
        });
    }
    else {
      axios.post
        (
          `${window._env_.REACT_APP_APIS}/${data.Receipt.UpdateTransactions}`,
          transactionDetailRequest,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            // Adopt the token for the version just written, or the next save echoes the one
            // this screen was opened with and falsely conflicts.
            if (res.data.wmtransactionheader?.concurrencyToken) {
              setTransaction((prev) => ({ ...prev, concurrencyToken: res.data.wmtransactionheader.concurrencyToken }));
            }
            handleClickOpen();
            setDisable(false);
            resetErrors();
          }
          else {
            alert(res.data.message, "Error");
            setDisable(false);
            resetErrors();
          }
        })
        .catch((err) => {
          // A real version conflict comes back as 409 and the shared interceptor has already
          // raised the reload dialog. Don't stack this screen's own error handling on top.
          if (err?.[CONCURRENCY_HANDLED]) {
            return;
          }
          // A refusal is now a real 4xx, so it lands here instead of the else branch above. This catch
          // previously reset state without telling the user anything.
          alert(getApiErrorMessage(err, MESSAGES.ERROR), "Error");
          setDisable(false);
          resetErrors();
        });
    }
  };

  const closeDialogForTransaction = () => {
    let itemArray = [];
    dispatch(Reset_Items(itemArray));
    //getTransactionData();
    handleClose();
    history.push("/wm/transaction");
  };

  const handleClicPopUpkOpen = () => {
    setaddConsigneePopup(true);
  };

  const hideConsigneePopup = () => {
    setaddConsigneePopup(false);
  };

  const handleClickOpen = () => {
    if (props.rolePermission === PermissionsConstants.TransactionReceipt) {
      dialogMessage1 = (receiptIdVar == "" ? "New Receipt Created!" : "Receipt Updated!");
      dialogMessage2 = "Your receipt has been " + (receiptIdVar == "" ? "created" : "updated") + ". Do you want to create another ?";
    }
    else {
      dialogMessage1 = (receiptIdVar == "" ? "New Shipment Created!" : "Shipment Updated!");
      dialogMessage2 = "Your shipment has been " + (receiptIdVar == "" ? "created" : "updated") + ". Do you want to create another ?";
    }

    setOpenDialogForTransaction(true);
  };

  const handleClose = () => {
    setOpenDialogForTransaction(false);

  };

  const createNewReceiptAgain = () => {
    handleClose();
    handelReset();
  };

  const disableConsigneeInput = () => {

    if (props.rolePermission === PermissionsConstants.TransactionReceipt) {
      setConsigneeInfoInputToDisable(true);
      setConsigneeIdInputToDisable(true);
      setConsigneeSearchDisable(true);
    } else {
      setConsigneeInfoInputToDisable(false);
      setConsigneeIdInputToDisable(false);
      setConsigneeSearchDisable(false);
    }
  };

  const [
    showOnlyShippersAttachedToCustomer,
    setShowOnlyShippersAttachedToCustomer,
  ] = useState(false);
  const [
    showOnlyConsigneeAttachedToCustomers,
    setshowOnlyConsigneeAttachedToCustomers,
  ] = useState(false);
  const { rolePermissions } = props.ReceiptReducer;
  const checkUserPermissions = () => {
    let consigneeAttached = false;
    let shipperAttached = false;

    if (rolePermissions) {
      if (rolePermissions[PermissionsConstants.TransactionReceipt] && Array.isArray(rolePermissions[PermissionsConstants.TransactionReceipt])) {
        for (var i = 0; i < rolePermissions[PermissionsConstants.TransactionReceipt].length; i++) {
          var perm = PermissionsConstants.TransactionReceipt + rolePermissions[PermissionsConstants.TransactionReceipt][i];

          if (perm === PermissionsConstants.TransactionReceiptViewOnlyShippersAttachedToCustomer) {
            setShowOnlyShippersAttachedToCustomer(true);
            shipperAttached = true;
          }

          if (perm === PermissionsConstants.TransactionReceiptViewOnlyConsigneeAttachedToCustomers) {
            setshowOnlyConsigneeAttachedToCustomers(true);
            consigneeAttached = true;
          }

          if (perm === PermissionsConstants.TransactionReceiptDelete) {
            setAllowedReceiptDeleteBtn(true);
          }
        }
      }

      if (rolePermissions[PermissionsConstants.TransactionShipment] && Array.isArray(rolePermissions[PermissionsConstants.TransactionShipment])) {
        for (var i = 0; i < rolePermissions[PermissionsConstants.TransactionShipment].length; i++) {
          var perm = PermissionsConstants.TransactionShipment + rolePermissions[PermissionsConstants.TransactionShipment][i];

          if (perm === PermissionsConstants.TransactionShipmentDelete) {
            setAllowedShipmentDeleteBtn(true);
            break;
          }
        }
      }
    }

    return {
      consigneeAttached: consigneeAttached,
      shipperAttached: shipperAttached,
    };
  };

  const buildDetailRequest = () => {
    let filteredPermissions = [];
    let showItemsWithZeroQuantity = false;
    let itemStatus = "";
    let showonlyActiveLots = false;
    Object.entries(rolePermissions).map(([key, values]) => {
      console.log(key);
      if (key === PermissionsConstants.TransactionReceipt) {
        values.forEach((val) => {
          filteredPermissions.push(key + val);
        });
      }
      filteredPermissions.forEach((perm) => {
        if (
          perm ===
          PermissionsConstants.TransactionReceiptViewItemsWithZeroQuantity
        ) {
          showItemsWithZeroQuantity = true;
        }

        if (
          perm === PermissionsConstants.TransactionReceiptViewOnlyActiveItems
        ) {
          itemStatus = "A";
        }

        if (
          perm === PermissionsConstants.TransactionReceiptViewOnlyActiveLots
        ) {
          showonlyActiveLots = true;
        }
      });
    });

    let builtRequest = {
      itemStatus: itemStatus,
      showItemsWithZeroQuantity: showItemsWithZeroQuantity,
      showonlyActiveLots: showonlyActiveLots
    };

    return builtRequest;
  };

  const detailDataSource = createConcurrencyAwareStore({
      onConflict: refreshGridOnConflict(detailDataGrid, changeTotals),

    key: 'key',
    loadParams:
    {
      recordType: function () {
        return "R";
      },
      itemStatus: function () {
        var request = buildDetailRequest();
        return request.itemStatus;
      },
      transactionHeaderId: function () {
        return receiptIdVar == "" ? "00000000-0000-0000-0000-000000000000" : receiptIdVar;
      },
      showItemsWithZeroQuantity: function () {
        var request = buildDetailRequest();
        return request.showItemsWithZeroQuantity;
      },
      showonlyActiveLots: function () {
        var request = buildDetailRequest();
        return request.showonlyActiveLots;
      },
      isTransItmsOnly: function () {
        return false;
      },
      mode: function () {
        return detailDataGridMode;
      },
      customerId: function () {
        return customerRowId == null || customerRowId == undefined ? "" : customerRowId;
      }
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${data.Receipt.getReceiptItems}`,
    updateUrl: `${window._env_.REACT_APP_APIS}/${data.Receipt.changeReceiptItems2}`,
    onBeforeSend: function (method, ajaxOptions) {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    }
  });

  const onChangeReceiptQuantityUpdate = (e) => {

    if (receiptId == "") {
      alert("Please save record first.", "Error");
      detailDataGrid.current.instance().cancelEditData();
      e.cancel = true;
    }
    else {
      if (!e.newData.hasOwnProperty('detailrowid')) {
        e.newData['detailrowid'] = e.oldData['detailrowid'];
      }

      if (!e.newData.hasOwnProperty('headerrowid')) {
        e.newData['headerrowid'] = receiptId == "" ? "00000000-0000-0000-0000-000000000000" : receiptId;
      }

      if (!e.newData.hasOwnProperty('rowid')) {
        e.newData['rowid'] = e.oldData['rowid'];
      }

      if (!e.newData.hasOwnProperty('lotid')) {
        e.newData['lotid'] = e.oldData['lotid'];
      }

      if (!e.newData.hasOwnProperty('mode')) {
        e.newData['mode'] = detailDataGridMode;
      }

      // Optimistic concurrency: the version the grid was showing. This handler copies a
      // field whitelist rather than merging all of oldData, so the token must be listed.
      if (!e.newData.hasOwnProperty('concurrencyToken')) {
        e.newData['concurrencyToken'] = e.oldData['concurrencyToken'];
      }
    }

  };

  const onRowUpdated = (e) => {

    var count = detailCount;

    if (e.data.isselected) {
      count = count + 1;
    }
    else {
      count = count - 1;
    }

    setDetailCount(count);

    if (count == 0) {
      setCustomerDisabled(false);
    }
    else {
      setCustomerDisabled(true);
    }

    changeTotals();
  };

  const onSaved = (e) => {
    if (props.oidc.user.profile.hasOwnProperty("WMCLEARLOTFILTER") && props.oidc.user.profile.WMCLEARLOTFILTER == "Y") {
      if (e.hasOwnProperty("changes") && e.changes.length == 1 && e.changes[0].data.quantityorder != null) {
        var lotCodeColumnIndex = detailDataGrid.current.instance().getVisibleColumnIndex("lotcode");

        if (lotCodeColumnIndex >= 0) {
          var lotCodeFilterValue = detailDataGrid.current.instance().columnOption("lotcode", 'filterValue');

          if (lotCodeFilterValue != null && lotCodeFilterValue != "") {
            detailDataGrid.current.instance().columnOption("lotcode", 'filterValue', null);
            setFoucsToLotFilterTextBox = true;
          }
        }
      }
      }

  };

  const onContentReady = (e) => {
    if (setFoucsToLotFilterTextBox == true) {
      var lotCodeColumnIndex = detailDataGrid.current.instance().getVisibleColumnIndex("lotcode");

      if (lotCodeColumnIndex >= 0) {
        var editorElement = document.querySelector("#wmCreateReceiptDetailDataGrid tr.dx-row.dx-datagrid-filter-row > td:nth-child(" + (lotCodeColumnIndex + 1) + ") input");
        if (editorElement != null) {
          setTimeout(() => editorElement.focus(), 500);
        }
      }
      setFoucsToLotFilterTextBox = false;
    }

  };

  useEffect(() => {
    receiptIdVar = "";
    setHeaderId(receiptIdVar);
    dialogMessage1 = "";
    dialogMessage2 = "";

    if (props.oidc.user.profile.hasOwnProperty("WMDETAILDATAGRIDMODE")) {
      detailDataGridMode = props.oidc.user.profile.WMDETAILDATAGRIDMODE;
      setSelectedValue(props.oidc.user.profile.WMDETAILDATAGRIDMODE);
    }

    setIsDisabled(disableTransDate(props.oidc.user.profile.LOGINTYPEID));
    checkUserPermissions();
    loadShipperAutoComponentData();
    loadCarrierAutoComponentData();
    loadProfileAutoComponentData();
    loadCustomerAutoComponentData();
    loadConsigneeAutoComponentData();
    disableConsigneeInput();
    if (!props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") || props.oidc.user.profile.LOGINTYPEID != ABECASUSER_LOGIN_TYPE) {
      loadTransactionFromProfile("");
    }
    detailDataGrid.current.instance().option("dataSource", detailDataSource);
  }, []);

  const onUpdateTransaction = () => {
    /*
    if (props.rolePermission === PermissionsConstants.TransactionReceipt) {
      history.push("/wm/transaction/change-receipt");
    } else {
      history.push("/wm/transaction/change-shippment");
    }*/
    handleClose();
  };

  const [lookupDataList, setLookupDataList] = useState([]);
  const [openLookupForm, setOpenLookupForm] = useState(false);

  let [lookupSearchRequest, setLookupSearchRequest] = useState({
    identityIdFrom: "",
    identityIdTo: "",
    name: "",
    lookupType: 0,
    showOnlyConsigneeAttachedToCustomers: showOnlyConsigneeAttachedToCustomers,
    showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
  });

  const getAllLookupsData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        lookupSearchRequest,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        console.log(res, "res");
        setLookupDataList(res.data.lookups);
      })
      .catch((err) => {
        console.log(err, "err in loading lookups data");
      });
  };
  let [lookupFormName, setLookupFormName] = useState("");
  const openSearchIdsForm = (lookupType) => {
    lookupSearchRequest = {
      identityIdFrom:
        lookupType === consigneeLookup
          ? consigneeData != null && consigneeData.identityId != null
            ? consigneeData.identityId
            : ""
          : lookupType === shipperLookup
            ? shipperData != null && shipperData.identityId != null
              ? shipperData.identityId
              : ""
            : lookupType === carrierLookup
              ? carrierData != null && carrierData.identityId != null
                ? carrierData.identityId
                : ""
              : customerData != null && customerData.identityId != null
                ? customerData.identityId
                : "",
      identityIdTo: "",
      name: "",
      lookupType: lookupType,
      showOnlyConsigneeAttachedToCustomers: showOnlyConsigneeAttachedToCustomers,
      showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    };

    setLookupSearchRequest({
      ...lookupSearchRequest,
      identityIdFrom:
        lookupType === consigneeLookup
          ? consigneeData != null && consigneeData.identityId != null
            ? consigneeData.identityId
            : ""
          : lookupType === shipperLookup
            ? shipperData != null && shipperData.identityId != null
              ? shipperData.identityId
              : ""
            : lookupType === carrierLookup
              ? carrierData != null && carrierData.identityId != null
                ? carrierData.identityId
                : ""
              : customerData != null && customerData.identityId != null
                ? customerData.identityId
                : "",
    });

    setLookupFormName(
      lookupType === consigneeLookup ? "Consignee" : lookupType === shipperLookup ? "Shipper" : lookupType === carrierLookup ? "Carrier" : "Customer"
    );
    setOpenLookupForm(true);
    getAllLookupsData();
  };
  const closeLookupSearchForm = () => {
    setOpenLookupForm(false);
    setLookupSearchRequest({
      identityIdFrom: "",
      identityIdTo: "",
      name: "",
      lookupType: 0,
      showOnlyConsigneeAttachedToCustomers:
        showOnlyConsigneeAttachedToCustomers,
      showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    });
  };

  const { identityIdFrom, identityIdTo, name } = lookupSearchRequest;
  const onLookupFieldChange = (e) => {

    if (e.event) {
      const name = e.event.target.name; // Get the name of the TextBox
      const value = e.value; // Get the new value
      setLookupSearchRequest({
        ...lookupSearchRequest,
        [name]: value,
      });
    }
  };
  const resetLookupForm = () => {
    lookupSearchRequest = {
      identityIdFrom: "",
      identityIdTo: "",
      name: "",
      lookupType:
        lookupFormName === "Consignee"
          ? 0
          : lookupFormName === "Shipper"
            ? 1
            : lookupFormName === "Carrier"
              ? carrierLookup : customerLookup,
      showOnlyConsigneeAttachedToCustomers:
        showOnlyConsigneeAttachedToCustomers,
      showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    };

    setLookupSearchRequest({
      identityIdFrom: "",
      identityIdTo: "",
      name: "",
      lookupType:
        lookupFormName === "Consignee"
          ? 0
          : lookupFormName === "Shipper"
            ? 1
            : lookupFormName === "Carrier"
              ? carrierLookup : customerLookup,
      showOnlyConsigneeAttachedToCustomers:
        showOnlyConsigneeAttachedToCustomers,
      showOnlyShippersAttachedToCustomer: showOnlyShippersAttachedToCustomer,
    });

    //dataGrid.current.instance().deselectAll();

    getAllLookupsData();
  };
  const onSearchLookupIds = () => {
    getAllLookupsData();
  };
  const onSelectionChanged = ({ selectedRowsData }) => {

    const lengthArray = selectedRowsData.length;
    let selectedLookupData = selectedRowsData[lengthArray - 1];

    let arr = [];
    arr.push(selectedLookupData);
    if (lookupFormName === "Consignee") {
      setTransaction({
        ...transaction,
        rConsignee: selectedLookupData == null ? "" : selectedLookupData.rowid,
        consigneeVal: selectedLookupData == null ? "" : selectedLookupData.name,
      });

      setConsigneeData(selectedLookupData);
      setGuidForConsignee(selectedRowsData);
      setConsigneeInfo(getConsigneeInfo(selectedLookupData));
    } else if (lookupFormName === "Shipper") {
      setTransaction({
        ...transaction,
        rShipper: selectedLookupData == null ? "" : selectedLookupData.rowid,
        shipperVal: selectedLookupData == null ? "" : selectedLookupData.name,
      });

      setshipperData(selectedLookupData);
      setGuidForShipper(selectedRowsData);

    } else if (lookupFormName === "Carrier") {
      setTransaction({
        ...transaction,
        rCarrier: selectedLookupData == null ? "" : selectedLookupData.rowid,
        carrierVal: selectedLookupData == null ? "" : selectedLookupData.name,
      });

      setCarrierData(selectedLookupData);
      setGuidForCarrier(selectedRowsData);
    }
    else {
      setTransaction({
        ...transaction,
        rCustomer: selectedLookupData == null ? "" : selectedLookupData.rowid,
        customerVal: selectedLookupData == null ? "" : selectedLookupData.name,
      });

      setCustomerData(selectedLookupData);
      setGuidForCustomer(selectedRowsData);
      customerRowId = selectedLookupData?.rowid;
      if (detailDataGrid.current?.instance()) {
        detailDataGrid.current.instance().refresh();
      }
    }
  };



  const [profileLookupDataList, setProfileLookupDataList] = useState([]);
  const [openProfileLookupForm, setOpenProfileLookupForm] = useState(false);
  let [profileLookupSearchRequest, setProfileLookupSearchRequest] = useState({
    code: "",
    description: ""
  });

  const getAllProfileLookupsData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchProfileLookup}`,
        profileLookupSearchRequest,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        console.log(res, "res");
        setProfileLookupDataList(res.data.lookups);
      })
      .catch((err) => {
        console.log(err, "err in loading lookups data");
      });
  };
  const openProfileSearchIdsForm = () => {
    profileLookupSearchRequest = {
      code: profileData != null && profileData.code != null ? profileData.code : "",
      description: ""
    };

    setProfileLookupSearchRequest({
      ...profileLookupSearchRequest,
      code: profileData != null && profileData.code != null ? profileData.code : ""
    });

    setOpenProfileLookupForm(true);
    getAllProfileLookupsData();
  };

  const closeProfileLookupSearchForm = () => {
    setOpenProfileLookupForm(false);
    setProfileLookupSearchRequest({
      code: "",
      description: ""
    });
  };

  const { code, description } = profileLookupSearchRequest;
  const onProfileLookupFieldChange = (e) => {

    if (e.event) {
      setProfileLookupSearchRequest({
        ...profileLookupSearchRequest,
        [e.target.name]: e.target.value,
      });
    }
  };
  const resetProfileLookupForm = () => {
    profileLookupSearchRequest = {
      code: "",
      description: ""
    };

    setProfileLookupSearchRequest({
      code: "",
      description: ""
    });

    profileDataGrid.current.instance().deselectAll();
    getAllProfileLookupsData();
  };

  const onSearchProfileLookupIds = () => {
    getAllProfileLookupsData();
  };
  const onProfileSelectionChanged = ({ selectedRowsData }) => {
    let selectedLookupData = selectedRowsData[0];

    let arr = [];
    arr.push(selectedLookupData);
    setTransaction({
      ...transaction,
      rProfile: selectedLookupData == null ? "" : selectedLookupData.rowid,
      profileVal: selectedLookupData == null ? "" : selectedLookupData.code,
    });


    setProfileData(selectedLookupData);
    setGuidForProfile(selectedRowsData);
    loadTransactionFromProfile(selectedLookupData?.rowid);

  };





  const handleSearchForConsignee = (e) => {
    var permissions = checkUserPermissions();
    let key = e.target.value;
    const lookup = 0;
    let request = {
      identityIdFrom: key,
      lookupType: lookup,
      isAutoComplete: true,
      showOnlyConsigneeAttachedToCustomers: permissions.consigneeAttached,
      showOnlyShippersAttachedToCustomer: permissions.shipperAttached,
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForConsignee(resp.data.lookups);
        /*
        setConsigneeData(
          resp.data.lookups.length > 0 ? resp.data.lookups[0] : {}
        );
        setConsigneeInfo(
          getConsigneeInfo(
            resp.data.lookups.length > 0 ? resp.data.lookups[0] : {}
          )
        );
        */
      });
  };
  const debouncedChangeHandlerForConsignee = useCallback(
    debounce(handleSearchForConsignee, 600),
    []
  );
  const handleSearchForShipper = (e) => {
    var permissions = checkUserPermissions();
    let key = e.target.value;
    const lookup = 1;
    let request = {
      identityIdFrom: key,
      lookupType: lookup,
      isAutoComplete: true,
      showOnlyConsigneeAttachedToCustomers: permissions.consigneeAttached,
      showOnlyShippersAttachedToCustomer: permissions.shipperAttached,
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForShipper(resp.data.lookups);
        /*
        setshipperData(
          resp.data.lookups.length > 0 ? resp.data.lookups[0] : {}
        );
        */
      });
  };
  const debouncedForShipper = useCallback(
    debounce(handleSearchForShipper, 800),
    []
  );

  const onItemClick = (e) => {
    setTransaction({ ...transaction, freightChargeType: e.value });
  }

  const handleSearchForCarrier = (e) => {
    let key = e.target.value;
    const lookup = 2;
    let request = {
      identityIdFrom: key,
      lookupType: lookup,
      isAutoComplete: true,
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForCarrier(resp.data.lookups);
        /*
        setCarrierData(
          resp.data.lookups.length > 0 ? resp.data.lookups[0] : {}
        );
        */
      });
  };

  const debouncedForCarrier = useCallback(
    debounce(handleSearchForCarrier, 800),
    []
  );

  const handleSearchForCustomer = (e) => {
    let key = e.target.value;
    const lookup = 3;
    let request = {
      identityIdFrom: key,
      lookupType: lookup,
      isAutoComplete: true,
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForCustomer(resp.data.lookups);
      });
  };

  const debouncedForCustomer = useCallback(
    debounce(handleSearchForCustomer, 800),
    []
  );

  const handleSearchForProfile = (e) => {
    let key = e.target.value;
    let request = {
      code: key,
      isAutoComplete: true
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SearchProfileLookup}`,
        request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((resp) => {
        setGuidForProfile(resp.data.lookups);
      });
  };

  const debouncedForProfile = useCallback(
    debounce(handleSearchForProfile, 800),
    []
  );

  const renderConsigneeSearchButton = (disableConsigneeSearch) => {
    if (disableConsigneeSearch) {
      return (

        <Button
          icon="search"

          stylingMode="text"

        />

      );
    } else {
      return (
        /*        <span
                 style={{
                   cursor: "pointer",
                   padding: "5px 2px"
                 }}
               >
                 <SearchIcon onClick={() => openSearchIdsForm(0)} />
               </span> */
        <Button
          icon="search"
          onClick={() => openSearchIdsForm(0)}
          stylingMode="text"

        />

      );
    }
  };
  const backToMainGrid = () => {
    let itemArray = [];
    dispatch(Reset_Items(itemArray));
    props.resetQueryForm(null);
    props.transactionCallbackOnUnCheck(0);
    history.push("/wm/transaction");
  };
  const getConsigneeInfo = (data) => {
    let consigneeInfo = "";
    if (data != undefined) {
      consigneeInfo = "Name: ";
      if (data.name !== undefined && data?.name !== null && data?.name !== "") {
        consigneeInfo += data.name.trim();
      }

      consigneeInfo += "\r\nAddress: ";

      if (data.address1 !== undefined && data?.address1 !== null && data?.address1 !== "") {
        consigneeInfo += data.address1.trim();
        consigneeInfo += "\r\n";

      }

      if (data.address2 !== undefined && data?.address2 !== null && data?.address2 !== "") {
        consigneeInfo += data.address2.trim();
        consigneeInfo += "\r\n";

      }
      if (data.city !== undefined && data?.city !== null && data?.city !== "") {
        consigneeInfo += data.city.trim() + " ";
      }

      if (data.state !== undefined && data?.state !== null && data?.state !== "") {
        consigneeInfo += data.state.trim() + " ";
      }

      if (data.zip !== undefined && data?.zip !== null && data?.zip !== "") {
        consigneeInfo += data.zip.trim();
      }
      consigneeInfo += "\r\n";
      if (data.country !== undefined && data?.country !== null && data?.country !== "") {
        consigneeInfo += data.country.trim();
      }
    }

    return consigneeInfo;

    /*
    if (
      data != undefined &&
      data.name !== undefined &&
      data.address1 !== undefined
    )
      return (
        "Name: " +
        (data?.name == null ? "" : data?.name) +
        "\n" +
        "Address: " +
        (data?.address1 == null ? "" : data?.address1)
      );
    return "";
    */
  };
  const [currentLayout, setCurrentLayout] = useState("Default");

  const gridKey = "b5f31590-6e75-4dd0-930c-408b07b514e4";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
  //////////Shipper AutoComponent///////////////////////
  const shipperRef = useRef({});
  const [dateSourceSupplier, setDateSourceSupplier] = useState(null);
  const handleShipperChange = useCallback((e) => {

    console.log(e);
    setshipperData(e.value);
  }, []);
  const loadShipperAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetShipperLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });
    setDateSourceSupplier(dataSourceDB);
  }, []);

  const ApplyFilterForShipperAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetShipperLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });
    setDateSourceSupplier(dataSourceDB);
  }
  //////////Shipper AutoComponent///////////////////////
  //////////Carrier AutoComponent///////////////////////
  const carrierRef = useRef({});
  const handleCarrierChange = useCallback((e) => {

    console.log(e);
    setCarrierData(e.value);
  }, []);
  const loadCarrierAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var shipperDataSource = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCarrierLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });
    setDataSource(shipperDataSource);
    // if (carrierRef.current.instance) {
    //   carrierRef.current.instance().option('dataSource', shipperDataSource);
    // }

  }, []);

  const ApplyFilterForCarrierAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const shipperDataSource = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCarrierLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });
    setDataSource(shipperDataSource);
  }
  //////////Carrier AutoComponent///////////////////////
  //////////Profile AutoComponent///////////////////////
  const [dateSourceProfile, setDateSourceProfile] = useState(null);
  let profileDataState = "";
  const handleProfileChange = (e) => {

    console.log(e);
    if (e.event) {
      const newValue = e.value;
      if (profileDataState !== e.value.rowid) {
        profileDataState = e.value?.rowid;
        setProfileData(e.value);
        loadTransactionFromProfile(newValue?.rowid);
      };
    }
  };


  const loadProfileAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var dataSourceDb = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetProfileLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });

    setDateSourceProfile(dataSourceDb);
  }, []);

  const selectionChanged = useCallback(
    (e, tg) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        return newStatus;
      });
    },
    [selectedItems, setSelectedItems],
  );
  const ApplyFilterForProfileAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const dataSourceDb = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetProfileLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`,
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });

    setDateSourceProfile(dataSourceDb);
  }
  //////////Profile AutoComponent///////////////////////  
  //////////Customer AutoComponent///////////////////////
  const CustomerRef = useRef({});
  const [dateSourceCustomer, setDateSourceCustomer] = useState(null);
  const handleCustomerChange = useCallback((e) => {

    console.log(e);
    setCustomerData(e.value);
    customerRowId = e.value?.rowid;
    if (detailDataGrid.current?.instance()) {
      detailDataGrid.current.instance().refresh();
    }
  }, []);
  const loadCustomerAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCustomerLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });
    setDateSourceCustomer(dataSourceDB);
  }, []);

  const ApplyFilterForCustomerAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetCustomerLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`,
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });
    setDateSourceCustomer(dataSourceDB);
  }
  //////////Customer AutoComponent/////////////////////// 
  //////////Consignee AutoComponent///////////////////////
  const ConsigneeRef = useRef({});
  const [dateSourceConsignee, setDateSourceConsignee] = useState(null);
  const handleConsigneeChange = useCallback((e) => {

    console.log(e);
    setCustomerData(e.value);
    setConsigneeData(e.value);
    if (e.value != undefined) {
      setConsigneeInfo(getConsigneeInfo(e.value));
    }
    else {
      setConsigneeInfo("");
    }

  }, []);
  const loadConsigneeAutoComponentData = useCallback(() => {
    var permissions = checkUserPermissions();
    var dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetConsigneeLookupPaging`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });

    setDateSourceConsignee(dataSourceDB);
  }, []);
  const handelTransactionDateChange = (e) => {

    const name = "transactionDate";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };

  const handelShippingDateChange = (e) => {
    const name = "actualreceivedshipeddate";
    const value = e.value;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (props.oidc.user.profile.hasOwnProperty("WMTRANSDATECONTROL") && props.oidc.user.profile.WMTRANSDATECONTROL == "B") {
      if (value) {
        if (new Date(value) < today) {
          notify(
            {
              message: "Receiving date must be greater than today's date",
              width: 100,
            },
            'error',
            3000,
          );
          setTransaction((prevTransaction) => ({
            ...prevTransaction,
            [name]: null,
          }));
          return;
        }
      }
    }
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };

  const ApplyFilterForConsigneeAutoComponent = (identityId) => {
    var permissions = checkUserPermissions();
    const dataSourceDB = new DataSource({
      store: new createStore({
        key: 'rowid',
        loadParams: {
          consigneeAttached: function () {
            return permissions.consigneeAttached;
          },
          shipperAttached: function () {
            return permissions.shipperAttached;
          }
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Transaction/GetConsigneeLookupPaging`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`,
          };
        },
      }),
      filter: ['identityId', '=', identityId],
      paginate: true,
      pageSize: 100,
    });
    setDateSourceConsignee(dataSourceDB);
  }
  //////////Customer AutoComponent/////////////////////// 


   
  const handelUerDefinedReference2rChange = (e) => {

    const name = "userDefinedReference2";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };

  const handelSalesOrderChange = (e) => {

    const name = "transactionGroup";
    const value = e.value;
    setTransaction((prevTransaction) => ({
      ...prevTransaction,
      [name]: value,
    }));
  };

  const hideLoadPanel = useCallback(() => {
    setLoadPanelVisible(false);
  }, [setLoadPanelVisible]);
  return (
    <div>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={position}
        onHiding={hideLoadPanel}
        visible={loadPanelVisible}
        showIndicator={showIndicator}
        shading={shading}
        showPane={showPane}
        hideOnOutsideClick={hideOnOutsideClick}
      />
      <div className="row">
        <div className="col-md-12 main-page">
          <div id="accordion" >
            <form onSubmit={(e) => onSaveTransaction(e)}>
              <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={e => {
                  if (e.currentTarget === e.target) {
                    selectionChanged(e, e.target);
                  }
                }}
                className=""
                itemTitleRender={() => (
                  <ToolbarAccordian className="accordian-toolbar">
                    <ItemAccordian location="before">
                      <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          {props.rolePermission === PermissionsConstants.TransactionReceipt
                            ? "Create New Receipt "
                            : "Create New Shipment"}
                        </h6>
                      </div>
                    </ItemAccordian>
                    <ItemAccordian location="after">
                      <Button className="accordianButton" text="Save" type="default"
                        disabled={disable} onClick={(e) => onSaveTransaction(e)} />
                    </ItemAccordian>
                    <ItemAccordian location="after">
                      {(props.rolePermission === PermissionsConstants.TransactionReceipt && allowedReceiptDeleteBtn) || allowedShipmentDeleteBtn ?
                        (
                          <div>
                            <Button
                              onClick={(e) => handleOpenDeleteReceiptDialog(e)}

                              className="accordianButton"
                              disabled={deleteButtonDisabled}
                              text="Delete"
                            >
                            </Button>
                            <DeleteReceiptDialog
                              open={deleteReceiptDialogOpen}
                              handleClose={handleCloseDeleteReceiptDialog}
                              rowid={receiptId}
                              transactionNumber={transaction.transactionNumber}
                            />
                          </div>
                        )
                        : ("")
                      }
                    </ItemAccordian>
                    <ItemAccordian location="after">
                      <Button
                        className="accordianButton"
                        onClick={(e) => exportReport(e)}
                        disabled={printButtonDisabled}
                      >
                        <LoadIndicator  style={{height: "16px", width: "16px", display: "inline-bloc",  verticalAlign: "middle", marginRight: "5px"}} visible={loadIndicatorVisible} />
                        <span className="dx-button-text">Print</span>
                      </Button>
                    </ItemAccordian>
                    <ItemAccordian location="after">
                      <Button className="accordianButton" text="Back" onClick={backToMainGrid} />
                    </ItemAccordian>
                  </ToolbarAccordian>
                )}
                itemRender={(itemProps) => (
                  <div style={{ height: '238px', overflowY: 'auto' }}>
                    {props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE ?
                      <div className="row">
                        <div className="col-md-3 d-flex align-items-center ">
                          <div className="col-md-11 auto-complete-selectbox">
                            <SelectBox
                              dataSource={dateSourceProfile}
                              value={profileData}
                              searchEnabled={true}
                              disabled={profileDisabled}
                              searchMode="contains"
                              onValueChanged={(e) => handleProfileChange(e)}

                              label="Profile Code:"
                              labelMode='static'
                              stylingMode='outlined'
                              displayExpr="code"
                            >
                            </SelectBox>
                          </div>
                          {profileDisabled ? (
                            <span></span>
                          ) : (
                            <Button
                              icon="search"
                              onClick={() => openProfileSearchIdsForm()}
                              stylingMode="text"
                            />
                          )}
                        </div>
                        <div className="col-md-3 d-flex align-items-center ">
                          <div className="col-md-11 auto-complete-selectbox">
                            <SelectBox
                              dataSource={dateSourceCustomer}
                              value={customerData}
                              searchEnabled={true}
                              disabled={customerDisabled}
                              searchMode="contains"
                              onValueChanged={(e) => handleCustomerChange(e)}
                              label="Customer ID:"
                              labelMode='static'
                              stylingMode='outlined'
                              displayExpr="identityId"

                            >
                            </SelectBox>
                          </div>

                          {customerDisabled ? (
                            <span></span>
                          ) : (
                            <Button
                              icon="search"
                              onClick={() => openSearchIdsForm(customerLookup)}
                              stylingMode="text"

                            />

                          )}
                        </div>
                        <div className="col-md-3">
                          <DateBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Transaction Date:"
                            defaultValue=''
                            type="date"
                            name="transactionDate"
                            disabled={isDisabled}
                            value={transaction.transactionDate}
                            onValueChanged={(e) => handelTransactionDateChange(e)}
                            showClearButton={true}
                          />
                          {transaction.transactionDate === "" ? (
                            <span className="error-span">{dateError}</span>
                          ) : (
                            <span></span>
                          )}
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            id="transactionNo"
                            disabled
                            name="transactionNumber"
                            stylingMode='outlined'
                            labelMode="static"
                            label="Transaction No:"
                            defaultValue=""
                            value={transaction.transactionNumber}
                          />
                        </div>
                      </div>
                      :
                      <div className="row">
                        <div className="col-md-3">
                          <DateBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Transaction Date:"
                            defaultValue=''
                            type="date"
                            name="transactionDate"
                            disabled={isDisabled}
                            value={transaction.transactionDate}
                            onValueChanged={(e) => handelTransactionDateChange(e)}
                            showClearButton={true}
                          />
                          {transaction.transactionDate === "" ? (
                            <span className="error-span">{dateError}</span>
                          ) : (
                            <span></span>
                          )}
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            id="transactionNo"
                            disabled
                            name="transactionNumber"
                            stylingMode='outlined'
                            labelMode="static"
                            label="Transaction No:"
                            defaultValue=""
                            value={transaction.transactionNumber}
                          />
                        </div>
                        <div className="col-md-3 d-flex align-items-center ">
                          <div className="col-md-11 auto-complete-selectbox">
                            <SelectBox
                              dataSource={dataSource}
                              value={carrierData}
                              searchEnabled={true}
                              searchMode="contains"
                              onValueChanged={(e) => handleCarrierChange(e)}
                              label="Carrier ID:"
                              labelMode='static'
                              stylingMode='outlined'
                              displayExpr="identityId"
                            />
                          </div>
                          <Button
                            icon="search"
                            onClick={() => openSearchIdsForm(carrierLookup)}
                            stylingMode="text"
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            id="transaction-reference"
                            name="reference"
                            stylingMode='outlined'
                            labelMode="static"
                            label="P.O. No:"
                            defaultValue=""
                            value={transaction.reference}
                            onValueChanged={(e) => handelreferenceChange(e)}
                          >
                          </TextBox>
                        </div>
                      </div>
                    }
                    <div className="row accordianLastRow">
                      <div className="col-md-3 d-flex align-items-center ">
                        {props.rolePermission === PermissionsConstants.TransactionReceipt ? (
                          <div className="col-md-11 auto-complete-selectbox"  >
                            <SelectBox
                              dataSource={dateSourceConsignee}
                              value={consigneeData}
                              disabled={consigneeIdInputToDisable}
                              searchEnabled={true}
                              searchMode="contains"
                              onValueChanged={(e) => handleConsigneeChange(e)}
                              label="Consignee ID:"
                              labelMode='static'
                              stylingMode='outlined'
                              displayExpr="identityId"
                            >
                            </SelectBox>
                          </div>
                        )
                          :
                          (
                            <div className="col-md-9 auto-complete-selectbox">
                              <SelectBox
                                dataSource={dateSourceConsignee}
                                value={consigneeData}
                                disabled={consigneeIdInputToDisable}
                                searchEnabled={true}
                                searchMode="contains"
                                onValueChanged={(e) => handleConsigneeChange(e)}
                                label="Consignee ID:"
                                labelMode='static'
                                stylingMode='outlined'
                                displayExpr="identityId"

                              >
                              </SelectBox>
                            </div>
                          )
                        }

                        {renderConsigneeSearchButton(consigneeSearchDisable)}
                        {props.rolePermission === PermissionsConstants.TransactionReceipt ? (
                          ""
                        ) : props.oidc.user.profile.hasOwnProperty("CREATECONSIGNEE") && props.oidc.user.profile.CREATECONSIGNEE === "Y" ? (
                          <div >
                            <Button id="btnAddConsignee" className="accordianButton custom-button_min_width" onClick={handleClicPopUpkOpen} type="default" text="Add">
                            </Button>

                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-3 d-flex align-items-center ">
                        <div className="col-md-11 auto-complete-selectbox">
                          <SelectBox
                            dataSource={dateSourceSupplier}
                            value={shipperData}
                            searchEnabled={true}
                            searchMode="contains"
                            onValueChanged={(e) => handleShipperChange(e)}
                            label="Shipper ID:"
                            labelMode='static'
                            stylingMode='outlined'
                            displayExpr="identityId"
                          >
                          </SelectBox>
                        </div>
                        <Button
                          icon="search"
                          onClick={() => openSearchIdsForm(1)}
                          stylingMode="text"

                        />


                      </div>
                      <div className="col-md-3">
                        <TextBox
                          id="transactionNo"
                          name="shipperBolNumber"
                          stylingMode='outlined'
                          labelMode="static"
                          label="Shipper BOL:"
                          defaultValue=""
                          value={transaction.shipperBolNumber}
                          onValueChanged={(e) => handelShipperBolChange(e)}
                        />
                      </div>

                      {(props.oidc.user.profile.hasOwnProperty("RECVSHIPDTACCESS") && props.oidc.user.profile.RECVSHIPDTACCESS == "A") ? (
                        <div className="col-md-3">
                          <DateBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Receiving/Shipping Date:"
                            defaultValue=''
                            type="date"
                            name="actualreceivedshipeddate"
                            value={transaction.actualreceivedshipeddate}
                            onValueChanged={(e) => handelShippingDateChange(e)}
                            showClearButton={true}
                          />
                          {/* {transaction.actualreceivedshipeddate === "" ? (
                            <span className="error-span">{dateError}</span>
                          ) : (
                            <span></span>
                          )} */}
                        </div>
                      ) : (props.oidc.user.profile.hasOwnProperty("RECVSHIPDTACCESS") && props.oidc.user.profile.RECVSHIPDTACCESS == "B") ? (
                        <div className="col-md-3">
                          <DateBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Receiving/Shipping Date:"
                            defaultValue=''
                            type="date"
                            disabled="true"
                            name="actualreceivedshipeddate"
                            value={transaction.actualreceivedshipeddate}
                            onValueChanged={(e) => handelShippingDateChange(e)}
                          />
                        </div>
                      ) : ""}





                    </div>
                    <div className="row accordianLastRow">
                      <div className="col-md-3">
                        <TextArea
                          value={consigneeInfo}
                          label="Consignee Info"
                          labelMode='static'
                          stylingMode='outlined'
                          readOnly={true}
                        />

                      </div>
                      <div className="col-md-3">
                        <TextArea
                          name="comment"
                          value={transaction.comment}
                          onValueChanged={(e) => handelCommentChange(e)}
                          label="Comment"
                          labelMode='static'
                          stylingMode='outlined'
                        >
                        </TextArea>
                      </div>
                      {props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") &&
                        props.oidc.user.profile.LOGINTYPEID === ABECASUSER_LOGIN_TYPE && (
                          <>
                            <div className="col-md-3 d-flex  ">
                              <div className="col-md-11 auto-complete-selectbox">
                                <SelectBox
                                  dataSource={dataSource}
                                  value={carrierData}
                                  searchEnabled={true}
                                  searchMode="contains"
                                  onValueChanged={(e) => handleCarrierChange(e)}
                                  label="Carrier ID:"
                                  labelMode="static"
                                  stylingMode="outlined"
                                  displayExpr="identityId"
                                />
                              </div>
                              <Button
                                icon="search"
                                onClick={() => openSearchIdsForm(carrierLookup)}
                                stylingMode="text"
                                style={{ paddingTop: '10px' }}
                              />
                            </div>
                            <div className="col-md-3">
                              <TextBox
                                id="transaction-reference"
                                name="reference"
                                stylingMode="outlined"
                                labelMode="static"
                                label="P.O. No:"
                                defaultValue=""
                                value={transaction.reference}
                                onValueChanged={(e) => handelreferenceChange(e)}
                              />
                            </div>
                          </>
                        )}
                      {props.rolePermission === PermissionsConstants.TransactionShipment
                        ?
                        <div className={`col-md-3 ${isAbecasUser ? 'accordianLastRow' : ''}`}>
                          <div className="col-md-12 auto-complete-selectbox">
                            <SelectBox
                              items={[
                                { Name: "None", tab: 0, ID: "N" },
                                { Name: "Prepaid", tab: 1, ID: "P" },
                                { Name: "Collect", tab: 2, ID: "C" },
                                { Name: "Bill Third Party", tab: 3, ID: "B" }
                              ]}
                              searchMode="contains"
                              label="Freight Charge Type:"
                              labelMode='static'
                              stylingMode='outlined'
                              displayExpr="Name"
                              valueExpr="ID"
                              onValueChanged={onItemClick}
                              defaultValue="N"
                            >
                            </SelectBox>
                          </div>

                        </div>
                        : ""}

                      {
                        props.rolePermission === PermissionsConstants.TransactionShipment ?
                          <div className={`col-md-3 ${isAbecasUser ? 'accordianLastRow' : ''}`}>
                            <TextBox
                              id="transactionGroup"
                              name="transactionGroup"
                              stylingMode='outlined'
                              labelMode="static"
                              label="Sales Order No:"
                              defaultValue=""
                              value={transaction.transactionGroup}
                              onValueChanged={(e) => handelSalesOrderChange(e)}
                            />
                          </div> : null
                      }
                      {props.rolePermission === PermissionsConstants.TransactionShipment
                        ?
                        <div className={`col-md-3 ${isAbecasUser ? 'accordianLastRow' : ''}`}>
                        <TextBox
                          id="userDefinedReference2"
                          name="userDefinedReference2"
                          stylingMode='outlined'
                          labelMode="static"
                          label={Localization.formatMessage('WMTRANSACTIONHEADER.USERDEFINEDREFERENCE_2', 'Trucker Ref:')}
                          defaultValue=""
                          value={transaction.userDefinedReference2}
                          onValueChanged={(e) => handelUerDefinedReference2rChange(e)}
                        />
                      </div>
                        : ""}
                     
                    </div>
                    <div style={{ display: 'flex', border: '0px solid black', marginTop: '12px' }}>
                      <div style={{ flex: 1, padding: '2px', marginLeft: '15px', width: '10vw', borderTopLeftRadius: '12px', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Record #:
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {transaction.recordNumber || ''}
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Total Lines:
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {selectedTotals.items}
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Ordered:
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {selectedTotals.ordered}
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Actual:
                      </div>
                      <div style={{ flex: 1, padding: '2px', marginRight: '15px', width: '10vw', borderTopRightRadius: '12px', borderTop: '1px solid ' + (window._env_.Color2), borderLeft: '1px solid ' + (window._env_.Color2), borderRight: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {selectedTotals.actual}
                      </div>
                    </div>
                    <div style={{ display: 'flex', border: '0px solid black', marginBottom: '12px' }}>
                      <div style={{ flex: 1, padding: '2px', marginLeft: '15px', width: '10vw', borderBottomLeftRadius: '12px', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Net Weight:
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {selectedTotals.netWeight}
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Gross Weight:
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {selectedTotals.grossWeight}
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                        Amount:
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        {selectedTotals.amount}
                      </div>
                      <div style={{ flex: 1, padding: '2px', width: '10vw', border: '1px solid ' + (window._env_.Color2), backgroundColor: window._env_.Color2, color: 'white', textAlign: 'center' }}>
                      </div>
                      <div style={{ flex: 1, padding: '2px', marginRight: '15px', width: '10vw', borderBottomRightRadius: '12px', border: '1px solid ' + (window._env_.Color2), color: 'black', textAlign: 'center' }}>
                        &nbsp;
                      </div>
                    </div>
                  </div>
                )}
                id="accordion-container"
              />
            </form>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "0px" }}>
        <ItemModeGrid
          key={reloadKey}
          displayItemModeGrid={displayItemModeGrid}
          detailDataGridModes={detailDataGridModes}
          selectedValue={selectedValue}
          detailDataGridModeChanged={detailDataGridModeChanged}
          searchPanelStatus={searchPanelStatus}
          headerId={headerId}
          selectedCustomerId={selectedCustomerId}
        />
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
          id="wmCreateReceiptDetailDataGrid"
          remoteOperations={true}
          showBorders={true}
          ref={detailDataGrid}
          hoverStateEnabled={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
          className={searchPanelStatus ? "StyleGridHightWithAccordianOpen" : "StyleGridHightWithAccordianClose"}
          onRowUpdating={(e) => onChangeReceiptQuantityUpdate(e)}
          onRowUpdated={onRowUpdated}
          onSaved={(e) => onSaved(e)}
          onContentReady={(e) => onContentReady(e)}
          visible={!displayItemModeGrid}
        >
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <ColumnFixing enabled={true} />
          <ColumnHeaderFilter />
          <Export enabled={true} allowExportSelectedData={true} text="Export" />
          <Sorting visible={true} mode="multiple" />
          <LoadPanel enabled={true} />
          <Paging defaultPageSize={100} />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
          />
          <FilterRow visible={true} />
          <Editing mode="cell" allowUpdating={true} refreshMode="repaint" />
          <FilterPanel visible={true} />
          <HeaderFilter visible={false} />
          <GroupPanel visible={true} />
          <Grouping autoExpandAll={false} />
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={loadState}
            storageKey={gridKey}
            customSave={saveState}
          />
          <Column dataField="isselected" dataType="boolean" caption="">
          </Column>
          <Column
            dataField="quantityorder"
            dataType="number"
            caption="Ordered"
          ></Column>
          <Column
            dataField="itemcode"
            caption="Item"
            allowEditing={false}
          ></Column>
          <Column
            dataField="description1"
            caption="Item Description - 1"
            allowEditing={false}
          ></Column>

          <Column
            dataField="classcode"
            caption="Class"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataField="palletsizecode"
            caption="PalletSizeCode"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataField="subclasscode"
            caption="SubClass"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataField="status"
            caption="Status"
            allowEditing={false}
          ></Column>
          <Column
            dataType="date"
            dataField="dateavailable"
            caption="Item Date Available"
            allowEditing={false}
          ></Column>
          <Column
            dataType="date"
            dataField="dateexpiration"
            caption="Item Date Expiration"
            allowEditing={false}
          ></Column>
          <Column
            dataField="netavailable"
            caption="Item Net Avl"
            allowEditing={false}
          ></Column>
          <Column
            dataField="receiptuomdefault"
            caption="UOM Default"
            allowEditing={false}
          ></Column>
          <Column
            dataField="receiptpacksize"
            caption="Pack Size"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column dataField="lotcode" caption="Lot" allowEditing={false}></Column>
          <Column
            dataField="lotDescription1"
            caption="Lot Description - 1"
            allowEditing={false}
          ></Column>
          <Column
            dataField="lotDescription2"
            caption="Lot Description - 2"
            allowEditing={false}
            visible={false}>
          </Column>
          <Column
            dataField="lotUserdefinedreference8"
            caption="Lot Reference 8"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataField="lotNetavailable"
            caption="Lot Net Avl"
            allowEditing={false}></Column>
          <Column
            dataType="date"
            dataField="lotDateExpiration"
            caption="Lot Date Expiration"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataType="date"
            dataField="LotDateAvailable"
            caption="Lot Date Available"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataType="date"
            dataField="LotDateIntroduced"
            caption="Lot Date Introduced"
            allowEditing={false}
            visible={false}
          ></Column>
          <Column
            dataField="lotUnitPerPackage"
            caption="Lot Units / Package"
            allowEditing={false}
            visible={false}>
          </Column>
          <Column
            dataField="lotFirstReceipt"
            caption="Lot First Receipt"
            allowEditing={false}
            visible={false}>
          </Column>
          <Toolbar>
            <Item>
              <SelectBox
                width="201"
                stylingMode='outlined'
                items={detailDataGridModes}
                displayExpr="text"
                valueExpr="value"
                value={selectedValue}
                onValueChanged={detailDataGridModeChanged} />
            </Item>
            <Item location="after">
              <GridLayoutManager gridKey={gridKey} dataGrid={detailDataGrid} setCurrentLayout={setCurrentLayout} />
            </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
          </Toolbar>
        </DataGrid>
      </div>
      <div style={{ flex: 1 }}>
        <div className="row">
          <div className="d-flex ">
            <LookupPopup
              openLookupForm={openLookupForm}
              closeLookupSearchForm={closeLookupSearchForm}
              onSearchLookupIds={onSearchLookupIds}
              resetLookupForm={resetLookupForm}
              onLookupFieldChange={onLookupFieldChange}
              identityIdFrom={identityIdFrom}
              identityIdTo={identityIdTo}
              name={name}
              lookupFormName={lookupFormName}
              lookupDataList={lookupDataList}
              dataGrid={dataGrid}
              onSelectionChanged={onSelectionChanged}
            />
            <LookupProfilePopup
              openLookupForm={openProfileLookupForm}
              closeLookupSearchForm={closeProfileLookupSearchForm}
              onSearchLookupIds={onSearchProfileLookupIds}
              resetLookupForm={resetProfileLookupForm}
              onLookupFieldChange={onProfileLookupFieldChange}
              code={code}
              description={description}
              lookupFormName="Profile"
              lookupDataList={profileLookupDataList}
              dataGrid={profileDataGrid}
              onSelectionChanged={onProfileSelectionChanged}
            />
            <Popup
              visible={openDialogForTransaction}
              onHiding={handleClose}
              title={dialogMessage1}
              showCloseButton={true}
              width={600} // Adjust width as needed
              height="auto" // Adjust height as needed
              className="cDialog"
            >
              <div className="row">
                <div className="col-12 d-flex justify-content-between p-0">

                </div>
              </div>
              <h5
                style={{
                  fontWeight: "500",
                  marginTop: "10px",
                }}
              >
                {dialogMessage2}
              </h5>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  marginLeft: '0px',
                  marginTop: '30px',
                }}
              >
                <Button
                  onClick={onUpdateTransaction}
                  className="accordianButton"
                  text="Add Details" type="default"
                >
                </Button>

                <Button
                  onClick={createNewReceiptAgain}
                  className="accordianButton"
                  text="New"
                >
                </Button>
                <Button
                  onClick={closeDialogForTransaction}
                  className="accordianButton"
                  text="Back"
                >

                </Button>

              </div>
            </Popup>

            {addConsigneePopup &&
              <Popup
                visible={addConsigneePopup}
                onHiding={hideConsigneePopup}
                dragEnabled={false}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title="Add Consignee"
                container="#root"
                closeOnOutsideClick={true}
                height="61vh"
                width="75vw"
              >
                <ScrollView width="100%" height="100%">
                  <Consignee
                    parentCallback={handleClosePopUpCallback}
                  ></Consignee>
                </ScrollView>
              </Popup>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(CreateReceipt);
